// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { AccountLogout, UpdateAccount } from '@actions/account';
import {
  UpdateOrganizationProfile,
  UpdateOrganizations,
} from '@actions/organization';

interface OrganizationProfile {
  _id?: string;
  organizationId?: string;
  [key: string]: unknown;
}

interface Organization {
  _id: string;
  profile?: OrganizationProfile;
  [key: string]: unknown;
}

interface AccountProfile {
  [key: string]: unknown;
}

interface AccountState {
  _id: string | null;
  loginType: string | null;
  isVerified: boolean | null;
  email: string | null;
  phoneNumber: string | null;
  profile: AccountProfile | null;
  organizations: Organization[] | null;
}

type UpdateAccountPayload = Partial<AccountState>;
type UpdateOrganizationsPayload = Organization;
type UpdateOrganizationProfilePayload = OrganizationProfile;

type UpdateAccountAction = Action<UpdateAccountPayload>;
type UpdateOrganizationsAction = Action<UpdateOrganizationsPayload>;
type UpdateOrganizationProfileAction = Action<UpdateOrganizationProfilePayload>;

const initialState: AccountState = {
  _id: null,
  loginType: null,
  isVerified: null,
  email: null,
  phoneNumber: null,
  profile: null,
  organizations: null,
};

export default handleActions<
  AccountState,
  | UpdateAccountPayload
  | UpdateOrganizationsPayload
  | UpdateOrganizationProfilePayload
  | void
>(
  {
    [UpdateAccount.toString()]: (
      state: AccountState,
      { payload }: UpdateAccountAction,
    ): AccountState => ({
      ...state,
      ...payload,
    }),
    [UpdateOrganizations.toString()]: (
      state: AccountState,
      { payload }: UpdateOrganizationsAction,
    ): AccountState => ({
      ...state,
      organizations: [
        payload,
        ...(state?.organizations || []).filter(
          (organization) => organization._id !== payload._id,
        ),
      ],
    }),
    [UpdateOrganizationProfile.toString()]: (
      state: AccountState,
      { payload }: UpdateOrganizationProfileAction,
    ): AccountState => ({
      ...state,
      organizations: [
        ...(state?.organizations?.map((org) =>
          org?._id === payload?.organizationId
            ? { ...org, profile: payload }
            : org,
        ) || []),
      ],
    }),
    [AccountLogout.toString()]: (): AccountState => initialState,
  },
  initialState,
);
